<template>
  <v-app class="t2d">
    <div class="t2d-page">
      <SiteHeader v-if="!hideAppBar"></SiteHeader>
      <main class="t2d-page__body">
        <router-view :key="$route.path" />
      </main>
      <ShareBar v-if="!hideAppBar"></ShareBar>
      <SiteFooter v-if="!hideAppBar"></SiteFooter>
    </div>
  </v-app>
</template>

<script>
// Same shell as the booking pages: white header (logo → website, phone,
// WhatsApp), share bar, footer. ?hide_app_bar=true still hides the chrome
// (the website embeds the form).
import SiteHeader from "@/components/shell/SiteHeader.vue";
import SiteFooter from "@/components/shell/SiteFooter.vue";
import ShareBar from "@/components/shell/ShareBar.vue";

export default {
  components: {
    SiteHeader,
    SiteFooter,
    ShareBar,
  },
  computed: {
    hideAppBar() {
      return this.$route.query.hide_app_bar === "true";
    },
  },
};
</script>

<style scoped>
.t2d-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f4f6f7;
}
.t2d-page__body {
  flex: 1 0 auto;
}
</style>
